export default __webpack_public_path__ + "deliver-3b0bbb6.png";